export const config = {
  name: 'author-course-settings',
}

export const prefixAction = (name: string): string => `${config.name}/${name}`
